import React from 'react';

type Props = { isAuthenticated: boolean; isAuthorized: boolean };

export function NotAuthorizedMessage(props: Props) {
  const { isAuthenticated, isAuthorized } = props;

  if (isAuthenticated && !isAuthorized) {
    const notAuthorizedMessage = 'You are not authorized for this site!';
    const hostElement = document.querySelector(
      '.o-form-content'
    ) as HTMLElement;

    const existingMfaWarning = hostElement?.querySelector('.not-authorized');
    if (existingMfaWarning) {
      existingMfaWarning.remove();
    }

    const messageDiv = document.createElement('div');
    messageDiv.textContent = notAuthorizedMessage;
    messageDiv.style.color = 'brown';
    messageDiv.style.margin = '0';
    messageDiv.style.display = 'contents';
    messageDiv.style.fontSize = '16px';
    messageDiv.style.fontWeight = 'bold';
    messageDiv.className = 'not-authorized';

    if (hostElement) {
      hostElement.append(messageDiv);
    }

    unlockWidget();
  }

  return <></>;
}

const unlockWidget = () => {
  document
    .querySelectorAll(
      '#okta-signin-username, #okta-signin-password, #okta-signin-submit'
    )
    .forEach((elem) => elem.removeAttribute('disabled'));
  document
    .querySelectorAll('.o-form-disabled')
    .forEach((elem) => elem.classList.remove('o-form-disabled'));
};
